import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import Loading from "../components/Loading";

const Layouts = lazy(() => import("../layouts/index"));

const LayoutsWithSuspense = () => (
  <Suspense fallback={<Loading open />}>
    <Layouts />
  </Suspense>
);

const RegistrationsListPage = lazy(() => import("../pages/registrations"));
const Wizard = lazy(() => import("../pages/wizard/index"));
const RegistrationsLayouts = lazy(
  () => import("../pages/registrations/Layouts"),
);
// const EditRegistrations = lazy(
//   () => import("../pages/registrations/EditRegistrations"),
// );
// const ViewRegistrations = lazy(
//   () => import("../pages/registrations/ViewRegistrations"),
// );
const DynamicListPage = lazy(
  () => import("../pages/registrations/dynamic/ListPage"),
);
const LCMDynamicListPage = lazy(
  () => import("../pages/registrations/LCMDynamic/ListPage"),
);
const DynamicViewPage = lazy(
  () => import("../pages/registrations/dynamic/ViewPage"),
);

const DynamicEditPage = lazy(
  () => import("../pages/registrations/dynamic/EditPage"),
);
const ProductDocuments = lazy(
  () => import("../pages/registrations/product/Documents"),
);

const ViewProduct = lazy(
  () => import("../pages/registrations/product/ViewProduct"),
);

const AppDetailsDynamicListPage = lazy(
  () => import("../pages/registrations/applicationDetails/ListPage"),
);
const AppDetailsDynamicEditPage = lazy(
  () => import("../pages/registrations/applicationDetails/EditPage"),
);
const AppDetailsDynamicViewPage = lazy(
  () => import("../pages/registrations/applicationDetails/ViewPage"),
);

const Documents = lazy(() => import("../pages/registrations/documents"));

const RecordMetadata = lazy(
  () => import("../pages/registrations/RecordMetadata"),
);

const EditRecordMetadata = lazy(
  () => import("../pages/registrations/RecordMetadata/EditRecordMetadata"),
);

const EPIPage = lazy(() => import("../pages/registrations/ePI"));

const IDMPPage = lazy(() => import("../pages/registrations/IDMP"));

const SubmissionDeatils = lazy(
  () => import("../pages/registrations/submissionDeatils"),
);

const RTQListPage = lazy(() => import("../pages/registrations/rtq"));

const GlobalSearchList = lazy(() => import("../pages/globalSearch/index"));

const AssociateProcessPage = lazy(
  () => import("../pages/workflow/AssociateProcessPage"),
);
const InitiateProcessPage = lazy(
  () => import("../pages/workflow/InitiateProcessPage"),
);
const MenuLayout = lazy(() => import("../pages/registrations/MenuLayout"));
const RegistrationDetailEntry = lazy(
  () => import("../pages/registrations/RegistrationDetailEntry"),
);

const routesForm = [
  {
    path: "/*",
    element: <Navigate to="/registrations" />,
  },
  {
    path: "/registrations",
    element: <LayoutsWithSuspense />,
    children: [
      {
        path: "",
        element: <RegistrationsListPage />,
      },
      {
        path: "global-search-list",
        element: <GlobalSearchList />,
      },
      {
        path: "associate-process/:recordId/:registrationId",
        element: <AssociateProcessPage />,
      },
      {
        path: "initiate-process/:registrationId/:processAssociationId/:recordId",
        element: <InitiateProcessPage />,
      },
      {
        path: ":regDetailMode/:registrationId",
        element: <RegistrationsLayouts />,
        children: [
          {
            index: true,
            element: <RegistrationDetailEntry />,
            handle: {
              breadcrumbLevel: "basicInfo",
            },
          },
          {
            path: ":menuId",
            element: <MenuLayout />,
            children: [
              {
                index: true,
                element: <DynamicListPage />,
                handle: {
                  breadcrumbLevel: "grid",
                },
              },
              {
                path: "add",
                element: <DynamicEditPage />,
                handle: {
                  breadcrumbLevel: "add",
                },
              },
              {
                path: "edit/:id",
                element: <DynamicEditPage />,
                handle: {
                  breadcrumbLevel: "edit",
                },
              },
              {
                path: "view/:id",
                element: <DynamicViewPage />,
                handle: {
                  breadcrumbLevel: "view",
                },
              },
            ],
          },
          {
            path: "documents",
            element: <Documents />,
          },
          {
            path: "recordmetadata",
            element: <MenuLayout />,
            children: [
              {
                index: true,
                element: <RecordMetadata />,
                handle: {
                  breadcrumbLevel: "grid",
                },
              },
              {
                path: "addmetadata/:docId",
                element: <EditRecordMetadata />,
                handle: {
                  breadcrumbLevel: "add",
                },
              },
              {
                path: "editmetadata/:docId/:id",
                element: <EditRecordMetadata />,
                handle: {
                  breadcrumbLevel: "edit",
                },
              },
              {
                path: "viewmetadata/:docId/:id",
                element: <EditRecordMetadata />,
                handle: {
                  breadcrumbLevel: "view",
                },
              },
            ],
          },
          {
            path: "ePI",
            element: <EPIPage />,
          },
          {
            path: "IDMP",
            element: <IDMPPage />,
          },
          {
            path: "rtq",
            element: <RTQListPage />,
          },
          {
            path: "product-documents",
            element: <ProductDocuments />,
          },
          {
            path: "product-info",
            element: <ViewProduct />,
            handle:{
              breadcrumbLevel: "viewProduct",
            }
          },
          {
            path: "commitments",
            element: <LCMDynamicListPage />,
          },
          {
            path: "obligations",
            element: <LCMDynamicListPage />,
          },
          {
            path: "local-changes",
            element: <LCMDynamicListPage />,
          },
          {
            path: "app-details", // grid page
            element: <MenuLayout />,
            children: [
              {
                index: true,
                element: <AppDetailsDynamicListPage />,
              },
              {
                path: "add", // add page
                element: <AppDetailsDynamicEditPage />,
              },
              {
                path: "edit/:id", // edit page
                element: <AppDetailsDynamicEditPage />,
              },
              {
                path: "view/:id", // view page
                element: <AppDetailsDynamicViewPage />,
              },
            ],
          },
          {
            path: "submission-details",
            element: <SubmissionDeatils />,
          },
        ],
      },
    ],
  },
  {
    path: "/wizard",
    element: <LayoutsWithSuspense />,
    children: [
      {
        path: "",
        element: <Wizard />,
      },
      {
        path: ":registrationId/:mode",
        element: <Wizard />,
      },
    ],
  },
];

const Router = createBrowserRouter(routesForm);

export { Router };
